import React, { useEffect, useState, Fragment, useContext } from "react";
import { Link } from "react-router-dom";
import { isUndefined } from "lodash";
import {
  NavItem,
  Nav,
  UncontrolledDropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
} from "reactstrap";
import { Trans } from "react-i18next";
import EmployeeContext from "contexts/EmployeeContext";
import { useOrganisationContext } from "./hooks/useOrganisationContext";
import { organisationIdState } from "./atoms";
import { useSetRecoilState } from "recoil";
import { useUserContext } from "./hooks";
import { useContactGroupsQuery } from "./queries";
// import PerfectScrollbar from 'react-perfect-scrollbar'

export const NavLinks = () => {
  const NavLink = ({ to, test, ...props }) =>
    !isUndefined(test) && !test ? null : (
      <NavItem>
        <Link to={`/${to}`} {...props} className="nav-link" />
      </NavItem>
    );

  const setOrganisationId = useSetRecoilState(organisationIdState);
  const { employees } = useContext(EmployeeContext);
  const { selectedOrganisation, organisations } = useOrganisationContext();
  const { data: contactGroups } = useContactGroupsQuery({
    useErrorBoundary: false,
  });
  const { 
    isAdmin, 
    isInTrialPeriod,
    // isAccounting, 
    // isWPConnect, 
    // isPayroll, 
    // isActive, 
  } = useUserContext();

  const [subscribedFeatures, setSubscribedFeatures] = useState({
    isAccounting: isInTrialPeriod,
    isWPConnect: isInTrialPeriod,
    isPayroll: isInTrialPeriod,
    isActive: isInTrialPeriod,
  })

  useEffect(() => {
    if (!isInTrialPeriod && selectedOrganisation?.subscribed_features) { 
      let subFeatures = selectedOrganisation?.subscribed_features
      let accounting = subFeatures?.hesaabmodule?.includes('accounting')
      let wpconnect = subFeatures?.hesaabmodule?.includes('wpconnect')
      let payroll = subFeatures?.hesaabmodule?.includes('payroll')
      let active = accounting || wpconnect || payroll

      setSubscribedFeatures({
        isAccounting: accounting,
        isWPConnect: wpconnect,
        isPayroll: payroll,
        isActive: active,
      })
    }

  }, [selectedOrganisation, ])

  const {
    isAccounting,
    isWPConnect,
    isPayroll,
    isActive
  } = subscribedFeatures

  return (
    <>
    {/* <aside className="left-sidebar" id="sidebarbg" data-sidebarbg="skin6">
            <div className="scroll-sidebar">
                <PerfectScrollbar className="sidebar-nav">
                    <Nav id="sidebarnav">
                                        <li className={' sidebar-item'} key="dsds">
                                            <NavLink to="test" className="sidebar-link" activeClassName="active">
                                                <i className='dasdas' />
                                                <span className="hide-menu">Kaka89</span>
                                            </NavLink> 

                                        </li> 
                                        <li className={' sidebar-item'} key={'dsadas'}>
                                            <NavLink to="test" className="sidebar-link" activeClassName="active">
                                                <i className='dasdas' />
                                                <span className="hide-menu">Kaka89</span>
                                            </NavLink> 

                                        </li> 
                            </Nav>                                
                </PerfectScrollbar>
            </div>
        </aside> */}
    <Nav navbar key="leftNav" className="mr-auto">
      <NavLink to="customer_invoices" test={isAdmin}>
        <Trans>Customer Invoices</Trans>
      </NavLink>
      <NavLink to="connect" test={isAdmin}>
        <Trans>Connect</Trans>
      </NavLink>
      <NavLink to="users" test={isAdmin}>
        <Trans>Users</Trans>
      </NavLink>
      <NavLink to="global_settings" test={isAdmin}>
        <Trans>Settings</Trans>
      </NavLink>
      <NavLink to="invoice_settings" test={isAdmin}>
        <Trans>Invoice Settings</Trans>
      </NavLink>

      {!!employees && (
        <NavLink to="employee_payroll">
          <Trans>Employee Payroll</Trans>
        </NavLink>
      )}

      {isActive && (
        <Fragment>
          <UncontrolledDropdown nav>
            <DropdownToggle nav caret>
            <img width="28"  
                src="/images/new-organization-icon.svg"
                alt="Arabic Invoicing Solution"
              />
            {/* <i className="fa fa-users" style={{color:'#72B566', fontSize:'16px', paddingRight:'4px'}}></i>  */}
              {selectedOrganisation ? (
                selectedOrganisation.name
              ) : (
                <Trans>Organisations</Trans>
              )}
            </DropdownToggle>
            <DropdownMenu>
              {organisations &&
                organisations.map((i) => (
                  <DropdownItem
                    key={i.id}
                    onClick={() => setOrganisationId(i.id)}
                  >
                    {i.status !== "LIVE" ? (
                      <span className="text-danger" >{i.name}</span>
                    ) : (
                      i.name
                    )}
                  </DropdownItem>
                ))}
              {!!(organisations && organisations.length) && (
                <DropdownItem divider />
              )}
              <Link className="dropdown-item" to="/organisations">
                <span className="fa fa-list fa-fw" /> <Trans>Manage</Trans>
              </Link>
              <Link className="dropdown-item" to="/organisations/new">
                <span className="fa fa-plus fa-fw" /> <Trans>Create</Trans>
              </Link>
            </DropdownMenu>
          </UncontrolledDropdown>

          {isAccounting && (
            <>
              <UncontrolledDropdown nav>
                <DropdownToggle nav caret>
                <img className="w-1 p-1"
                src="/images/accounts-icon.svg"
                alt="Arabic Invoicing Solution"
              />
                <Trans>Accounts</Trans>
                </DropdownToggle>
                <DropdownMenu>
                  <Link to="/bank/bank_accounts" className="dropdown-item">
                    <Trans>Bank Accounts</Trans>
                  </Link>
                  <Link to="/accounts_receivable" className="dropdown-item">
                    <Trans>Sales</Trans>
                  </Link>
                  <Link to="/purchases" className="dropdown-item">
                    <Trans>Purchases</Trans>
                  </Link>
                  <Link to="/quotes" className="dropdown-item">
                    <Trans>Quotes</Trans>
                  </Link>
                  <Link to="/expenses" className="dropdown-item">
                    <Trans>Expense Claims</Trans>
                  </Link>
                  <Link to="/inventory" className="dropdown-item">
                    <Trans>Inventory</Trans>
                  </Link>
                  <Link to="/settings/manual_journals/all" className="dropdown-item">
                    <Trans>Manual Journals</Trans>
                  </Link>
                </DropdownMenu>
              </UncontrolledDropdown>
              <UncontrolledDropdown nav>
                <DropdownToggle nav caret>
                <img className="w-1 p-1"
                src="/images/reports-icon.svg"
                alt="Arabic Invoicing Solution"
              />
                  <Trans>Reports</Trans>
                </DropdownToggle>
                <DropdownMenu>
                  <Link to="/reports/balance_sheet" className="dropdown-item">
                    <Trans>Balance Sheet</Trans>
                  </Link>
                  <Link to="/reports/bank_summary" className="dropdown-item">
                    <Trans>Bank Summary</Trans>
                  </Link>
                  <Link to="/reports/budget_summary" className="dropdown-item">
                    <Trans>Budget Summary</Trans>
                  </Link>
                  <Link
                    to="/reports/executive_summary"
                    className="dropdown-item"
                  >
                    <Trans>Executive Summary</Trans>
                  </Link>
                  <Link to="/reports/profit_and_loss" className="dropdown-item">
                    <Trans>Profit And Loss</Trans>
                  </Link>
                  <Link to="/reports/trial_balance" className="dropdown-item">
                    <Trans>Trial Balance</Trans>
                  </Link>
                  <Link
                    to="/reports/trial_balance_with_movement"
                    className="dropdown-item"
                  >
                    <Trans>Trial Balance with Movement</Trans>
                  </Link>
                  <Link to="/reports/sales_tax" className="dropdown-item">
                    <Trans>Sales Tax Report</Trans>
                  </Link>
                </DropdownMenu>
              </UncontrolledDropdown>
              <UncontrolledDropdown nav>
                <DropdownToggle nav caret>
                <img className="w-1 p-1"
                src="/images/contacts.svg"
                alt="Arabic Invoicing Solution"
              />
                  <Trans>Contacts</Trans>
                </DropdownToggle>
                <DropdownMenu>
                  <Link className="dropdown-item" to="/contacts">
                    <Trans>All Contacts</Trans>
                  </Link>
                  <Link
                    className="dropdown-item"
                    to="/contacts?isCustomer=true"
                  >
                    <Trans>Customers</Trans>
                  </Link>
                  <Link
                    className="dropdown-item"
                    to="/contacts?isSupplier=true"
                  >
                    <Trans>Suppliers</Trans>
                  </Link>
                  <DropdownItem divider />
                  {contactGroups &&
                    contactGroups.map((i) => (
                      <Link
                        className="dropdown-item"
                        key={i.ContactGroupID}
                        to={`/contacts?contactGroup=${i.ContactGroupID}`}
                      >
                        {i.Name}
                      </Link>
                    ))}
                  {!!(contactGroups && contactGroups.length) && (
                    <DropdownItem divider />
                  )}
                  <Link className="dropdown-item" to={`/contact_groups`}>
                    <span className="fa fa-list fa-fw" />
                    <Trans>Manage Groups</Trans>
                  </Link>
                  <Link to={`/contact_groups/new`} className="dropdown-item">
                    <span className="fa fa-plus fa-fw" />
                    <Trans>Create Group</Trans>
                  </Link>
                </DropdownMenu>
              </UncontrolledDropdown>
              <NavLink to="settings">
              <img className="w-1 p-1"
                src="/images/settings-icon.svg"
                alt="Arabic Invoicing Solution"
              />
                <Trans>Settings</Trans>
              </NavLink>
            </>
          )}
          {isPayroll && (
            <>
              <UncontrolledDropdown nav>
                <DropdownToggle nav caret>
                <img className="w-1 p-1"
                src="/images/payroll-icon.svg"
                alt="Arabic Invoicing Solution"
              />
                  <Trans>Payroll</Trans>
                </DropdownToggle>
                <DropdownMenu>
                  <Link to="/payroll/pay_runs" className="dropdown-item">
                    <Trans>Pay Runs</Trans>
                  </Link>
                  <Link to="/payroll/loans" className="dropdown-item">
                    <Trans>Loans</Trans>
                  </Link>
                  <Link to="/payroll/public_holidays" className="dropdown-item">
                    <Trans>Public Holidays</Trans>
                  </Link>
                  <Link to="/payroll/employees" className="dropdown-item">
                    <Trans>Employees</Trans>
                  </Link>
                  <Link to="/payroll/time_off" className="dropdown-item">
                    <Trans>Time off</Trans>
                  </Link>
                  <Link to="/payroll/tracks" className="dropdown-item">
                    <Trans>Tracks</Trans>
                  </Link>
                  <Link to="/payroll/allowance_rules" className="dropdown-item">
                    <Trans>Allowance Rules</Trans>
                  </Link>
                  <Link to="/payroll/deductions" className="dropdown-item">
                    <Trans>Deductions</Trans>
                  </Link>
                  <Link to="/payroll/provisions" className="dropdown-item">
                    <Trans>Provisions</Trans>
                  </Link>
                  <Link to="/payroll/settings" className="dropdown-item">
                    <Trans>Settings</Trans>
                  </Link>
                </DropdownMenu>
              </UncontrolledDropdown>
            </>
          )}
          {isWPConnect && (
            <NavLink to="wp-connect">
                <img className="w-1 p-1"
                src="/images/connect-icon.svg"
                alt="Arabic Invoicing Solution"
              />
              <Trans>WP Connect</Trans>
            </NavLink>
          )}
          <NavLink to="subscription" className="flag-icon">
          <img className="w-1 p-1"
                src="/images/subscription-icon.svg"
                alt="Arabic Invoicing Solution"
              />

            <Trans>Subscription</Trans>
          </NavLink>
        </Fragment>
      )}


    </Nav>
    </>
  );
};
